<template>
  <div class="home uk-text-center">

 

    <div class="uk-child-width-1-1@s" uk-grid>
      <!-- <div>
<h1 style="color:lightslategrey;font-size:63px" class="uk-margin-medium-top" >¿Cuál es tu sueño, meta, o necesidad para el 2021?</h1> -->
<!-- <p>Casa, auto, viaje, negocio... Si lo puedes pagar lo puedes lograr con un crédito. <i>Calcula tu capacidad de pago con este sencillo simulador</i>  </p> -->
      <!-- </div> -->
      <div>
   <img alt="logo" class="uk-margin-medium-top" src="../assets/img.jpg" style="max-width:300px" width="60%">
      </div>
    </div>

    

    <h3> Calcula cómo lograr tus sueños o metas con este sencillo simulador <br>Contesta las siguientes preguntas:</h3>
    <form id="first">

        <div class="uk-margin">
          <label style="font-size: 18px"> <b>Cuéntanos ¿Cuál es tu sueño o necesidad? </b>   <br></label><input required type="text" v-model="data['Finalidad']" class="uk-input" style="max-width:400px" placeholder="Descríbelo aquí">
        </div>

        <div class="uk-margin">
          <label style="font-size: 18px" class="uk-inline"> <b>¿Cuánto dinero necesitarás para lograrlo?</b> </label><input required type="number" v-model="data['4 Monto solicitado']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>
        <div class="uk-margin">
          <label style="font-size: 18px" class="uk-inline"> <b>¿Eres socio de la Cooperativa/Caja?</b> </label> <select required class="uk-select  uk-margin-medium-left uk-inline uk-form-width-medium">
            <option >Sí</option>
            <option >No</option>
          </select>  
        </div>

        <div class="uk-margin">
          <label style="font-size: 18px" class="uk-inline"> <b>¿En qué ciudad vives?</b> </label><input required type="text" v-model="data['Ciudad']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="Ciudad" >
        </div>


    <button type="submit"   class="uk-button uk-button-large uk-button-primary">Continuar</button>
</form>







<div id="modal" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
        <h3 class="uk-modal-title">Te ayudaremos a calcular cómo llegar a cumplir tu sueño</h3>


        <form id="form" action="4c">
          <label >Ingresa tus datos <br></label>
          <input required v-model="data['Nombre']" type="text" class="uk-input" placeholder="Nombre">
          <input required v-model="data['Telefono']" type="tel" class="uk-input" placeholder="Teléfono celular">
          <input v-model="data['Correo']" type="email" class="uk-input" placeholder="Correo">

          <label><input class="uk-checkbox" type="checkbox" required> He leido y acepto los <a class="uk-link-text uk-text-primary" href="https://verificagps-89c24.firebaseapp.com/privpol.html">términos y condiciones</a> <br> </label>
    
          <button v-if="!loading" type="submit" class="uk-button uk-button-primary uk-margin">Continuar</button>
          <span v-else uk-spinner></span>
        </form>
        
    </div>
</div>


  </div>
</template>

<script>
export default {
  name: 'Home',
  data:function(){
    return {
      data: {},
      loading : false,
      logo : '',
    }
  },
  methods:{
    next:function(){


        
        UIkit.modal(document.getElementById('modal')).show()
    

    },
    go:async function () {
      this.loading = true
      
      this.$score = this.data


      sessionStorage.setItem('data',JSON.stringify(this.$score))


      var date = new Date().getTime()

      sessionStorage.getItem('id') ? date = sessionStorage.getItem('id') : sessionStorage.setItem('id',date)

      UIkit.modal(document.getElementById('modal')).hide()

      this.loading = false

      this.$router.push('4c')
    }
  },
  mounted: async function(){
    
      var url_params = new URLSearchParams(window.location.search);
      const f = url_params.get('f')
      if(f && f != 'integral'){
        sessionStorage.setItem('f',f)
      } else {
        sessionStorage.setItem('f','integral')
      }
      this.logo = 'https://firebasestorage.googleapis.com/v0/b/verificagps-89c24.appspot.com/o/Prospecting_logo.jpg?alt=media&token=4c7a2260-1eac-49cd-92c8-51f84eae7f8d'

    document.getElementById('form').addEventListener('submit',function(e){
      e.preventDefault()
      this.go()
    }.bind(this))
    document.getElementById('first').addEventListener('submit',function(e){
      e.preventDefault()
      // this.next()
      this.go()
    }.bind(this))
  },
}
</script>
